const EVENT_KEY = {
  ENTER: 'Enter',
};

export const preventEnterKeySubmit = (event) => {
  if (event.key === EVENT_KEY.ENTER) {
    event.preventDefault();
  }
};
